import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { ICoordonneeBancaire, IDevise, Unsubscriber } from '@core';
import { IModeReception } from '@core-lib/models/mode-reception.model';
import {
	Cheque,
	PreferenceContact,
	PreferenceModeReception,
	PreferencesNotifications,
	ReleveAffaire
} from '@core-lib/models/preference.model';
import { ModeReceptionService } from '@core-lib/services/mode-reception.service';
import { PreferenceService } from '@core-lib/services/preference.service';
import { map, Observable } from 'rxjs';

@Component({
    selector: 'settings-page',
    templateUrl: './settings-page.component.html',
    standalone: false
})
export class SettingsPageComponent extends Unsubscriber implements OnInit {
	@Input() allowEdit: boolean;
	@Input() showContact: boolean;
	@Input() compteId: string;
	@Input() structureId: string;
	@Input() raisonSociale: string;
	@Input() devise: IDevise;
	@Input() coordonneeBancaire: ICoordonneeBancaire;

	@Output() reloadCurrentComptes = new EventEmitter<void>();

	modesReception$: Observable<IModeReception[]> = this.modeReceptionService.modesReception$.pipe(
		map(modesReception => modesReception.items.filter(modeReception => modeReception.actifEcarpa))
	);

	get preferenceModeReception$(): Observable<PreferenceModeReception> {
		return this.preferenceService.preferencesModeReception$;
	}

	get preferencesNotifications$(): Observable<PreferencesNotifications> {
		return this.preferenceService.preferencesNotifications$;
	}

	get preferencesCheques$(): Observable<Cheque> {
		return this.preferenceService.preferencesCheques$;
	}

	get preferencesReleveAffaires$(): Observable<ReleveAffaire> {
		return this.preferenceService.preferencesReleveAffaires$;
	}

	get preferenceContact$(): Observable<PreferenceContact> {
		return this.preferenceService.preferencesContact$;
	}

	constructor(
		private modeReceptionService: ModeReceptionService,
		private preferenceService: PreferenceService
	) {
		super();
	}

	ngOnInit(): void {
		this.modeReceptionService.getModesReceptionCarpa(true);
		this.preferenceService.get(this.structureId);
	}

	onReloadCurrentComptes() {
		this.reloadCurrentComptes.emit();
	}
}
